var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgSupport = function SvgSupport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 26",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.681 10.856h-.06V9.4c0-4.675-3.793-8.465-8.472-8.465-4.68 0-8.473 3.79-8.473 8.465v1.456H3.32C2.012 10.856 1 12.014 1 13.35v3.713a2.347 2.347 0 0 0 2.32 2.406h2.2a.565.565 0 0 0 .535-.624v-7.277c0-.357-.208-.713-.535-.713h-.655V9.4a7.28 7.28 0 0 1 7.284-7.277A7.28 7.28 0 0 1 19.433 9.4v1.456h-.654c-.327 0-.536.356-.536.713v7.277a.564.564 0 0 0 .536.624h.683l-.06.089a4.698 4.698 0 0 1-3.775 1.871 2.943 2.943 0 0 0-5.827.564 2.972 2.972 0 0 0 2.973 2.941 3.063 3.063 0 0 0 2.14-.92c.381-.39.63-.889.714-1.427a5.888 5.888 0 0 0 4.727-2.346l.565-.832c1.278-.089 2.081-.89 2.081-2.05v-3.712c0-1.277-.951-2.792-2.319-2.792ZM4.865 18.282H3.32a1.159 1.159 0 0 1-1.13-1.218V13.35c0-.683.476-1.307 1.13-1.307h1.545v6.238Zm9.187 4.9c-.33.358-.793.562-1.279.565a1.813 1.813 0 0 1-1.783-1.752 1.753 1.753 0 0 1 3.508-.002v.002c.024.44-.137.872-.446 1.188Zm7.759-5.821c0 .802-.773.92-1.13.92h-1.248v-6.237h1.248c.654 0 1.13.92 1.13 1.604v3.713Z",
    fill: "currentcolor",
    fillRule: "nonzero",
    stroke: "currentcolor"
  })));
};

export default SvgSupport;